var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 3,
    transform: "rotate(-180 32 32)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3516 15.6406C10.8438 16.1094 10.8438 16.9297 11.3516 17.3984L17.6016 23.6484C18.0704 24.1562 18.8907 24.1562 19.3595 23.6484C19.8673 23.1797 19.8673 22.3594 19.3595 21.8906L14.0079 16.5L19.3595 11.1484C19.8673 10.6797 19.8673 9.85938 19.3595 9.39062C18.8907 8.88281 18.0704 8.88281 17.6016 9.39062L11.3516 15.6406Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/PREVIOUS.d157edc6fc99a06e539bb043af9f9908.svg";
export { ForwardRef as ReactComponent };